import * as toastr from 'toastr'

toastr.options.closeButton = true
toastr.options.timeOut = 0
toastr.options.extendedTimeOut = 0

export default toastr
